import { createSlice } from "@reduxjs/toolkit";

const initialCustomerState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  customerForEdit: undefined,
  lastError: null,
  pdfLoading: false,
  csvLoading: false,
  excelLoading: false,
};

export const callTypes = {
  list: "list",
  action: "action",
  pdf: "pdf",
  csv: "csv",
  xlsx: "xlsx",
};

export const customerSetupSlice = createSlice({
  name: "customerSetup",
  initialState: initialCustomerState,
  reducers: {
    startCall: (state, action) => {
      state.lastError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.pdf) {
        state.pdfLoading = true;
      } else if (action.payload.callType === callTypes.csv) {
        state.csvLoading = true;
      } else if (action.payload.callType === callTypes.xlsx) {
        state.excelLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    catchError: (state, action) => {
      state.lastError = action.payload.error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.pdf) {
        state.pdfLoading = false;
      } else if (action.payload.callType === callTypes.csv) {
        state.csvLoading = false;
      } else if (action.payload.callType === callTypes.xlsx) {
        state.excelLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    customersFetched: (state, action) => {
      state.listLoading = false;
      state.entities = action.payload?.rows || [];
      state.totalCount = action.payload?.totalResults || 0;
      state.lastError = null;
    },
    customerFetchedForEdit: (state, action) => {
      state.actionsLoading = false;
      state.customerForEdit = action.payload.customerForEdit;
      state.lastError = null;
    },
    customerCreated: (state, action) => {
      state.actionsLoading = false;
      state.entities.unshift(action.payload);
      state.totalCount += 1;
      state.lastError = null;
    },
    customerUpdated: (state, action) => {
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) =>
        entity.Id === action.payload.updatedCustomer.Id
          ? action.payload.updatedCustomer
          : entity
      );
      state.lastError = null;
    },
    customerDeleted: (state, action) => {
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.Id !== action.payload.Id
      );
      state.totalCount -= 1;
      state.lastError = null;
    },
    pdfFetched: (state, action) => {
      state.pdfLoading = false;
    },
    csvFetched: (state, action) => {
      state.csvLoading = false;
    },
    excelFetched: (state, action) => {
      state.excelLoading = false;
    },
  },
});

export const { actions } = customerSetupSlice;